import { render, staticRenderFns } from "./CourseComponent.vue?vue&type=template&id=01e127d8"
import script from "./CourseComponent.vue?vue&type=script&lang=js"
export * from "./CourseComponent.vue?vue&type=script&lang=js"
import style0 from "./CourseComponent.vue?vue&type=style&index=0&id=01e127d8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports